// @ts-nocheck

import { useEffect, useState } from 'react'

import { CardValidationType } from 'Containers/ScheduleCampaignOld_merge/components/CreditCardForm/CreditCardFormProps'
import { useSelector } from 'react-redux'
import { getArtistBalance, getCountryName } from 'Redux/selectors/auth'
import { getCoupon } from 'Redux/selectors/scheduledCampaign'
import { colors } from 'Styled/variables'
import { getCampaignToSchedule } from 'Redux/selectors/campaigns'

declare const bluesnap

export const useBluesnapPayments = ({
  setIsLoading,
}: {
  setIsLoading?: (value?: boolean) => void
}): {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  bluesnapSecurityCardData: any
  initialiseBluesnap: (pfToken: string) => void
  reInitialiseBluesnap: (pfToken: string) => void
  bluesnapErrorText: string
  bluesnapIsButtonLoading: boolean
  isBluesnapButtonDisabled: boolean
  isBluesnapInitialized: boolean
  bluesnapSecurityCountry: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeCardData: (data: any) => void
  closeBluesnapErrorAlert: () => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  calculateTotalPrice: any
} => {
  const campaignToSchedule = useSelector(getCampaignToSchedule)
  const country = useSelector(getCountryName)
  const coupon = useSelector(getCoupon)
  const balance = useSelector(getArtistBalance)

  const [isBluesnapInitialized, setIsBluesnapInitialized] = useState<boolean>(
    false
  )
  const [bluesnapErrorText, setIsBluesnapErrorText] = useState<string | null>()
  const [ccnIsValid, setCcnIsValid] = useState<boolean>(false)
  const [cvvIsValid, setCvvIsValid] = useState<boolean>(false)
  const [expIsValid, setExpIsValid] = useState<boolean>(false)
  const [bluesnapSecurityCardData, setBluesnapSecurityCardData] = useState<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    any
  >()
  const [bluesnapSecurityCountry, setBluesnapSecurityCountry] = useState<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    any
  >()
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false)

  useEffect(() => {
    if (ccnIsValid && cvvIsValid && expIsValid) {
      setIsBluesnapErrorText('')
      setIsButtonDisabled(false)
    } else {
      setIsButtonDisabled(true)
    }
  }, [ccnIsValid, cvvIsValid, expIsValid])

  const closeBluesnapErrorAlert = () => {
    setIsBluesnapErrorText('')
  }

  const calculateTotalPrice = (): number => {
    const israelVat =
      country === 'IL' || country === 'ISR'
        ? campaignToSchedule.price * 0.17
        : 0
    const discount = coupon
      ? (campaignToSchedule.price + israelVat) * (coupon.discount / 100)
      : 0
    const resultPriceWithoutBalance =
      campaignToSchedule.price + israelVat - discount
    const resultPrice =
      resultPriceWithoutBalance > balance &&
      resultPriceWithoutBalance - balance >= 1
        ? resultPriceWithoutBalance - balance
        : 1
    return +resultPrice.toFixed(2)
  }

  const funcSetIsButtonLoading = (errorCode: number, tagId: string): void => {
    if (Number(errorCode) === 10 && ['cvv', 'exp', 'ccn'].includes(tagId))
      setIsButtonLoading(false)
  }

  const validateNewCard = ({ tagId, isValid }: CardValidationType) => {
    switch (tagId) {
      case 'ccn':
        setCcnIsValid(isValid)
        break
      case 'cvv':
        setCvvIsValid(isValid)
        break
      case 'exp':
        setExpIsValid(isValid)
        break
      default:
        break
    }
  }

  const onChangeCardData = data => {
    if (data.issuingCountry)
      setBluesnapSecurityCountry(data.issuingCountry.toUpperCase())
    else {
      setBluesnapSecurityCardData({
        last4Digits: data.cardLastFourDigits,
        ccType: data.cardType,
        amount: calculateTotalPrice(),
        currency: 'USD',
      })
      if (data.issuingCountryCode)
        setBluesnapSecurityCountry(data.issuingCountryCode.toUpperCase())
    }
  }

  const initialiseBluesnap = (pfToken: string): void => {
    const bsObj = {
      token: pfToken,
      onFieldEventHandler: {
        setupComplete() {
          setIsBluesnapInitialized(true)
        },
        threeDsChallengeExecuted() {
          // console.warn('threeDsChallengeExecuted')
        },
        onFocus() {
          // console.log(tagId)
        },
        onBlur() {
          // console.log(tagId)
        },
        onError(tagId, errorCode) {
          funcSetIsButtonLoading(tagId, errorCode)
          validateNewCard({ tagId, isValid: false })
          const errorCodeText = 'INVALID_CARD_TYPE'
          setIsBluesnapErrorText(errorCodeText)
        },

        onType(tagId, cardType, cardData) {
          if (cardData != null) {
            onChangeCardData(cardData)
          }
        },
        onValid(tagId) {
          validateNewCard({ tagId, isValid: true })
        },
      },

      style: {
        // Styling all inputs
        input: {
          padding: '13px 16px',
          width: '100%',
          height: '47px',
          'font-size': '14px',
          'line-height': '21px',
          color: `${colors.mainText}`,
          // 'border-width': '1px',
          // 'border-style': 'solid',
          // 'border-color': `${colors.greyStroke}`,
          // 'border-radius': '8px',
          outline: 'none',
        },
        '::placeholder': {
          color: `${colors.greyTextWhiteBg}`,
          opacity: 1,
        },
        ':-ms-input-placeholder': {
          color: `${colors.greyTextWhiteBg}`,
        },
        span: {
          color: '#646877',
          'font-size': '14px',
          'line-height': '21px',
        },
        '.invalid': {
          color: '#646877',
        },
        '.invalid:focus': {
          color: '#646877',
        },
      },
      ccnPlaceHolder: '4444 3333 2222 1111',
      cvvPlaceHolder: '000',
      expPlaceHolder: '12/27',
      '3DS': true,
    }
    pfToken && bluesnap.hostedPaymentFieldsCreate(bsObj)
  }

  const reInitialiseBluesnap = (pfToken: string): void => {
    pfToken && bluesnap.hostedPaymentFieldsUpdateToken(pfToken)
  }

  return {
    initialiseBluesnap,
    reInitialiseBluesnap,
    isBluesnapInitialized,
    bluesnapErrorText,
    bluesnapIsButtonLoading: isButtonLoading,
    bluesnapSecurityCardData,
    isBluesnapButtonDisabled: isButtonDisabled,
    bluesnapSecurityCountry,
    onChangeCardData,
    closeBluesnapErrorAlert,
    calculateTotalPrice,
  }
}
